import React, { Component } from "react";
import PropTypes from 'prop-types';
import { StatsTableHeader, StatsTablePlayer, StatsTableContent } from "../..";
import { GREEN_LIGHT } from "../../styles/shared/colors";
import "./StatsTable.scss";

class StatsTable extends Component {
  static propTypes = {
    onPlayerClick: PropTypes.func,
    selectedPlayerId: PropTypes.string,
    titles: PropTypes.array
  };

  static defaultProps = {
    onPlayerClick: ()=> {},
    selectedPlayerId: '',
    titles: []
  };

  state = {
    displayedData: {},
    isDesc: false,
    currentSortCategory: ""
  };

  static getDerivedStateFromProps(props, state) {
    if (Object.keys(state.displayedData).length <= 0) {
      return {
        displayedData: Object.entries(JSON.parse(JSON.stringify(props.data)))
      };
    }
    return {};
  }

  sortItems = category => {
    const { displayedData } = this.state;
    const data = Object.assign(displayedData);

    data.sort((a, b) => {
      if (typeof a[1].stats[category] !== "string") {
        if (a[1].stats[category] < b[1].stats[category]) {
          return -1;
        }
        if (a[1].stats[category] > b[1].stats[category]) {
          return 1;
        }
        return 0;
      } 
      // use to fix sort strings of format "XX-YY" 
      if (Number(a[1].stats[category].split("-")[0]) < Number(b[1].stats[category].split("-")[0])) {
        return -1;
      }
      if (Number(a[1].stats[category].split("-")[0]) > Number(b[1].stats[category].split("-")[0])) {
        return 1;
      }
      return 0;
    });

    this.setState(prevState => ({
      displayedData: prevState.isDesc ? data : data.reverse(),
      isDesc: !prevState.isDesc,
      currentSortCategory: category
    }));
  };

  render() {
    const { selectedPlayerId, onPlayerClick, titles } = this.props;
    const { displayedData, currentSortCategory, isDesc } = this.state;
    return (
      <div className="stats-table">
        <StatsTableHeader
          titles={titles}
          sortItems={this.sortItems}
          currentSortCategory={currentSortCategory}
          isDesc={isDesc}
        />
        {displayedData.map(player => {
          const id = player[0];
          return (
            <div
              key={id}
              className="stats-table__player"
              style={{
                backgroundColor: id === selectedPlayerId && GREEN_LIGHT
              }}
              onClick={() => onPlayerClick(id)}
            >
              <StatsTablePlayer
                playerNumber={player[1].playerNumber}
                name={player[1].name}
                avatar={player[1].avatar}
                avatarBgColor={player[1].avatarBgColor}
              />
              <StatsTableContent titles={titles} stats={player[1].stats} />
            </div>
          );
        })}
      </div>
    );
  }
}

export default StatsTable;
